import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import NavBar from './component/navbar';
import Footer from './component/footer';
import { Routes, Route } from 'react-router-dom';

import Home from './page/home';
import UserManualsAPI from './page/userManualsAPI';

function App() {

  document.title = "RMUTI API SERVICE"

  return (
    <div>
      <NavBar />
      <br />

      <Routes>
        <Route index element={<Home/>} />
        <Route path="/userManualsAPI" element={<UserManualsAPI/>} />
      </Routes>

      <br/>
      <Footer />

    </div>
  );
}

export default App;
